"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledUserOutlinedIcon = exports.StyledMyAccountIconButton = exports.StyledBackdrop = exports.Separator = exports.BackNavigation = exports.StyledNav = exports.StyledChevronLeft = exports.CartDrawerContainer = exports.SearchDrawContainer = exports.LanguageContainer = exports.SearchDrawer = exports.LanguageDrawer = exports.Drawer = exports.DownArrow = exports.LanguageSelectionButton = exports.StyledShoppingCartButton = exports.SearchButton = exports.StyledBmiLogo = exports.BurgerButton = exports.NavigationBarButtons = exports.NavigationBarContent = exports.NavigationBar = exports.UtilitiesBar = exports.StyledPaper = exports.classes = void 0;
const Button_1 = require("@mui/material/Button");
const Container_1 = require("@mui/material/Container");
const Link_1 = require("@mui/material/Link");
const Paper_1 = __importDefault(require("@mui/material/Paper"));
const SvgIcon_1 = require("@mui/material/SvgIcon");
const Tabs_1 = require("@mui/material/Tabs");
const Typography_1 = require("@mui/material/Typography");
const styles_1 = require("@mui/material/styles");
const Backdrop_1 = __importDefault(require("@mui/material/Backdrop"));
const icon_button_1 = __importStar(require("../icon-button"));
const shopping_cart_button_1 = __importDefault(require("../shopping-cart-button"));
const Bmi_1 = __importDefault(require("../logo/svgs/Bmi"));
const button_1 = __importStar(require("../button"));
const ChevronLeft_1 = __importDefault(require("../icon/svgs/ChevronLeft"));
const container_1 = __importDefault(require("../container"));
const UserOutlined_1 = __importDefault(require("../icon/svgs/UserOutlined"));
const PREFIX = "Header";
exports.classes = {
    utilitiesBar: `${PREFIX}-utilitiesBar`,
    navItem: `${PREFIX}-navItem`,
    utilitiesButton: `${PREFIX}-utilitiesButton`,
    downArrowUp: `${PREFIX}-downArrowUp`,
    languageSelectionButtonActive: `${PREFIX}-languageSelectionButtonActive`,
    languageIcon: `${PREFIX}-languageIcon`,
    closeButton: `${PREFIX}-closeButton`,
    backButton: `${PREFIX}-backButton`,
    showLanguageSelection: `${PREFIX}-showLanguageSelection`,
    navigationBar: `${PREFIX}-navigationBar`,
    navigation: `${PREFIX}-navigation`,
    navItemNoChildren: `${PREFIX}-navItemNoChildren`,
    navItemSelected: `${PREFIX}-navItemSelected`,
    searchButtonIsOnSearchPage: `${PREFIX}-searchButtonIsOnSearchPage`,
    searchDrawerContainerHidden: `${PREFIX}-searchDrawerContainerHidden`,
    cartDrawerContainerHidden: `${PREFIX}-cartDrawerContainerHidden`
};
const transitionTiming = "280ms cubic-bezier(0.4, 0, 0.2, 1)";
exports.StyledPaper = (0, styles_1.styled)(Paper_1.default)(({ theme }) => ({
    position: "sticky",
    top: 0,
    left: 0,
    width: "100%",
    zIndex: 10,
    "& ul": {
        marginBottom: 0,
        marginTop: 0,
        paddingLeft: 0
    },
    "& .footer": {
        position: "absolute",
        top: "3rem",
        right: 0
    },
    [`.${exports.classes.languageIcon}`]: {
        marginRight: "10px",
        width: "20px"
    },
    [`.${exports.classes.closeButton}`]: {
        backgroundColor: `${theme.colours.white} !important`,
        color: `${theme.colours.slate} !important`,
        position: "absolute",
        right: 0,
        top: 0,
        zIndex: 2,
        "&:hover": {
            backgroundColor: `${theme.colours.pearl} !important`,
            color: `${theme.colours.charcoal} !important`
        },
        [`&.${icon_button_1.iconButtonClasses.root}:hover`]: {
            backgroundColor: `${theme.colours.pearl} !important`,
            color: `${theme.colours.charcoal} !important`
        }
    },
    [`.${exports.classes.backButton}`]: {
        fontWeight: "bold",
        padding: "18px 10px 18px 2px",
        maxWidth: "230px",
        svg: {
            width: "24px"
        },
        [`.${Button_1.buttonClasses.root}`]: {
            justifyContent: "start"
        }
    }
})); // Need to cast, so we can use `component` composition property (https://mui.com/material-ui/guides/typescript/#complications-with-the-component-prop)
exports.UtilitiesBar = (0, styles_1.styled)("nav")(({ theme }) => ({
    backgroundColor: theme.colours.pearl,
    display: "none",
    paddingTop: "0.3rem",
    paddingBottom: "0.3rem",
    position: "relative",
    textAlign: "right",
    zIndex: 15,
    [theme.breakpoints.up("lg")]: {
        display: "block"
    },
    "& ul": {
        display: "flex",
        justifyContent: "flex-end"
    },
    [`.${exports.classes.navItem}`]: {
        display: "flex",
        alignItems: "center",
        [`&:hover .${Link_1.linkClasses.underlineHover}`]: {
            textDecoration: "none"
        },
        [`+ .${exports.classes.navItem}::before`]: {
            content: '""',
            display: "block",
            backgroundColor: theme.colours.storm,
            height: "24px",
            margin: "0 7px",
            width: "1px"
        }
    },
    [`.${exports.classes.utilitiesButton}`]: {
        [`&.${button_1.buttonClasses.root}`]: {
            fontSize: "0.875rem",
            color: theme.colours.charcoal
        }
    }
}));
exports.NavigationBar = (0, styles_1.styled)("div")(({ theme }) => ({
    backgroundColor: theme.colours.white,
    position: "relative",
    zIndex: 13,
    [`.${Container_1.containerClasses.root}`]: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
    }
}));
exports.NavigationBarContent = (0, styles_1.styled)("div")({
    display: "flex",
    alignItems: "flex-end",
    marginBottom: "-1px",
    width: "100%"
});
exports.NavigationBarButtons = (0, styles_1.styled)("div")(({ theme }) => ({
    display: "flex",
    alignSelf: "stretch",
    alignItems: "center",
    marginLeft: "auto",
    paddingLeft: "10px"
}));
exports.BurgerButton = (0, styles_1.styled)(icon_button_1.default)(({ theme }) => ({
    color: `${theme.colours.inter} !important`,
    marginLeft: "10px",
    [theme.breakpoints.up("lg")]: {
        display: "none"
    }
}));
exports.StyledBmiLogo = (0, styles_1.styled)(Bmi_1.default)(({ theme }) => ({
    margin: "10px 10px 10px 0",
    width: "50px",
    height: "50px"
}));
exports.SearchButton = (0, styles_1.styled)(icon_button_1.default)(({ theme }) => ({
    [`&.${icon_button_1.iconButtonClasses.contained}`]: {
        color: theme.colours.white,
        [theme.breakpoints.down("lg")]: {
            color: theme.colours.inter,
            backgroundColor: theme.colours.white,
            ":hover": {
                backgroundColor: theme.colours.white
            }
        }
    },
    [theme.breakpoints.up("lg")]: {
        [`.${exports.classes.searchButtonIsOnSearchPage}`]: {
            display: "none"
        }
    }
}));
exports.StyledShoppingCartButton = (0, styles_1.styled)(shopping_cart_button_1.default)(({ theme }) => ({
    marginLeft: "10px",
    [`&.${icon_button_1.iconButtonClasses.contained}`]: {
        color: theme.colours.white,
        [theme.breakpoints.down("lg")]: {
            color: theme.colours.inter,
            backgroundColor: theme.colours.white,
            ":hover": {
                backgroundColor: theme.colours.white
            }
        }
    },
    [theme.breakpoints.up("lg")]: {
        [`.${exports.classes.searchButtonIsOnSearchPage}`]: {
            display: "none"
        }
    }
}));
exports.LanguageSelectionButton = (0, styles_1.styled)(button_1.default)(({ theme }) => ({
    transition: `border ${transitionTiming}, padding-bottom ${transitionTiming}, margin-bottom ${transitionTiming}`,
    border: "1px solid transparent",
    [`&.${exports.classes.languageSelectionButtonActive}`]: {
        border: `1px solid ${theme.colours.storm}`,
        borderBottomColor: theme.colours.pearl,
        borderRadius: "4px 4px 0 0",
        marginBottom: "-0.5rem",
        paddingBottom: "0.875rem"
    }
}));
exports.DownArrow = (0, styles_1.styled)("span")({
    marginLeft: "1rem",
    transition: `transform ${transitionTiming}`,
    [`&.${exports.classes.downArrowUp}`]: {
        transform: "rotate(180deg)"
    }
});
exports.Drawer = (0, styles_1.styled)("div")(({ theme }) => ({
    height: "100vh",
    zIndex: 14,
    backgroundColor: theme.colours.white,
    border: `1px solid ${theme.colours.storm}`,
    position: "fixed",
    right: 0,
    top: 0,
    width: "315px",
    [theme.breakpoints.up("lg")]: {
        position: "absolute",
        top: "auto",
        height: "calc(100vh - 160px)",
        width: "100%",
        overflow: "hidden"
    }
}));
exports.LanguageDrawer = (0, styles_1.styled)(exports.Drawer)(({ theme }) => ({
    zIndex: 16,
    maxWidth: "1392px",
    margin: "0 auto",
    overflow: "auto",
    maxHeight: "unset",
    boxShadow: `0px 4px 5px ${(0, styles_1.alpha)(theme.colours.black, 0.14)}, 0px 1px 10px ${(0, styles_1.alpha)(theme.colours.black, 0.12)}, 0px 2px 4px -1px ${(0, styles_1.alpha)(theme.colours.black, 0.2)}`,
    backgroundColor: theme.colours.pearl,
    [`.${exports.classes.closeButton}`]: {
        backgroundColor: `${theme.colours.pearl} !important`,
        color: `${theme.colours.slate} !important`,
        margin: "18px",
        [`&.${icon_button_1.iconButtonClasses.root}:hover`]: {
            backgroundColor: `${theme.colours.pearl} !important`,
            color: `${theme.colours.charcoal} !important`
        }
    },
    [theme.breakpoints.up("lg")]: {
        left: 0,
        height: "auto",
        maxHeight: "calc(100vh - 60px)"
    }
}));
exports.SearchDrawer = (0, styles_1.styled)(exports.Drawer)(({ theme }) => ({
    padding: "30px",
    [theme.breakpoints.up("lg")]: {
        right: "20px",
        width: "566px",
        height: "auto"
    },
    [`.${Typography_1.typographyClasses.root}`]: {
        marginBottom: "32px"
    }
}));
exports.LanguageContainer = (0, styles_1.styled)(container_1.default)(({ theme }) => ({
    padding: "16px",
    [theme.breakpoints.up("lg")]: {
        padding: "32px 24px"
    }
}));
exports.SearchDrawContainer = (0, styles_1.styled)("div")(({ theme }) => ({
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    margin: "auto",
    maxWidth: theme.breakpoints.values.xl,
    zIndex: 15,
    [theme.breakpoints.up("lg")]: {
        top: "auto",
        zIndex: 14
    },
    [`&.${exports.classes.searchDrawerContainerHidden}`]: {
        display: "none"
    }
}));
exports.CartDrawerContainer = (0, styles_1.styled)("div")(({ theme }) => ({
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    margin: "auto",
    maxWidth: theme.breakpoints.values.xl,
    zIndex: 15,
    [theme.breakpoints.up("lg")]: {
        top: "auto"
    },
    [`&.${exports.classes.cartDrawerContainerHidden}`]: {
        display: "none"
    }
}));
exports.StyledChevronLeft = (0, styles_1.styled)(ChevronLeft_1.default)({
    height: "1.5rem",
    transition: "transform 120ms cubic-bezier(0.4, 0, 0.2, 1)",
    transform: "translateX(10px)",
    marginRight: "15px"
});
exports.StyledNav = (0, styles_1.styled)("nav")(({ theme }) => ({
    display: "none",
    [theme.breakpoints.up("lg")]: {
        display: "block",
        overflowX: "auto"
    },
    [`.${exports.classes.navItem}`]: {
        backgroundClip: "padding-box",
        border: "1px solid transparent",
        borderRadius: "3px 3px 0 0",
        minWidth: "auto",
        padding: "6px 12px",
        transition: `color ${transitionTiming}, background-color ${transitionTiming}, box-shadow ${transitionTiming}, border ${transitionTiming}`,
        textDecoration: "none",
        color: theme.colours.slate,
        fontSize: "16px",
        opacity: 1,
        "&:hover": {
            backgroundColor: theme.colours.pearl,
            color: theme.colours.charcoal
        },
        "&.Mui-selected": {
            border: `1px solid ${theme.colours.storm}`,
            borderBottomColor: theme.colours.white
        },
        flexDirection: "column-reverse",
        [`.${SvgIcon_1.svgIconClasses.root}`]: {
            marginBottom: 0,
            height: "16px",
            width: "16px"
        },
        [theme.breakpoints.up("lg")]: {
            flexDirection: "row-reverse",
            fontSize: "18px",
            padding: "10px 8px 10px 14px",
            [`.${SvgIcon_1.svgIconClasses.root}`]: {
                marginLeft: "3px",
                height: "24px",
                width: "24px"
            }
        }
    },
    [`.${exports.classes.navItemNoChildren}`]: {
        display: "flex",
        alignItems: "center"
    },
    [`.${exports.classes.navItemSelected}`]: {
        borderBottom: `5px solid ${theme.colours.inter} !important`,
        padding: "5px 8px 0px 14px !important"
    },
    [`.${Tabs_1.tabsClasses.indicator}`]: {
        display: "none"
    }
}));
exports.BackNavigation = (0, styles_1.styled)("div")(({ theme }) => ({
    backgroundColor: theme.colours.pearl,
    display: "block",
    position: "sticky",
    top: 0,
    zIndex: 1
}));
exports.Separator = (0, styles_1.styled)("hr")(({ theme }) => ({
    border: "none",
    borderTop: `1px solid ${theme.colours.alabaster}`,
    margin: "0 10px"
}));
exports.StyledBackdrop = (0, styles_1.styled)(Backdrop_1.default)(({ theme }) => ({
    zIndex: 14,
    [theme.breakpoints.up("lg")]: {
        zIndex: 12,
        [`&.${exports.classes.showLanguageSelection}`]: {
            zIndex: 13
        }
    }
}));
exports.StyledMyAccountIconButton = (0, styles_1.styled)(icon_button_1.default)(({ theme }) => ({
    marginLeft: "8px",
    [theme.breakpoints.up("lg")]: {
        display: "none",
        marginLeft: "12px"
    }
}));
exports.StyledUserOutlinedIcon = (0, styles_1.styled)(UserOutlined_1.default)(({ theme }) => ({
    fill: theme.colours.inter
}));
//# sourceMappingURL=data:application/json;base64,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